import { SVGProps } from 'react';

export default function Video(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg {...props} width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.38351 4H1.38482C1.045 4 0.769531 4.27547 0.769531 4.61528V11.3834C0.769531 11.7232 1.045 11.9987 1.38482 11.9987H9.38351C9.72333 11.9987 9.9988 11.7232 9.9988 11.3834V4.61528C9.9988 4.27547 9.72333 4 9.38351 4Z'
        fill='currentColor'
      />
      <path
        d='M15.083 4.35369C15.0384 4.32605 14.9874 4.3103 14.935 4.30793C14.8825 4.30556 14.8304 4.31665 14.7834 4.34015L11.0917 6.18601C11.0406 6.21163 10.9976 6.25099 10.9676 6.29969C10.9376 6.34838 10.9218 6.40447 10.9219 6.46166V9.53808C10.9219 9.59516 10.9378 9.65112 10.9678 9.69969C10.9977 9.74827 11.0407 9.78754 11.0917 9.81311L14.7834 11.659C14.8303 11.6825 14.8824 11.6936 14.9348 11.6913C14.9873 11.6889 15.0382 11.6733 15.0828 11.6457C15.1275 11.6181 15.1643 11.5796 15.1899 11.5338C15.2154 11.488 15.2289 11.4364 15.2289 11.3839V4.6158C15.2289 4.5633 15.2156 4.51165 15.1901 4.46577C15.1645 4.41989 15.1277 4.38131 15.083 4.35369Z'
        fill='currentColor'
      />
    </svg>
  );
}
